import Vue from 'vue';
import Router from 'vue-router';
import Home from '../App.vue';

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                title:'七牛云企业直播_微信私域直播系统_企业直播SaaS_0元试用7天_满意再付款',
                content: {
                    keywords: '企业直播系统,私域直播系统,直播SaaS',
                    description: '七牛云为企业提供一站式私域直播平台，价格低至3899元/年，0元用7天，满意再付款。1分钟创建专属直播间，丰富直播功能，支持千万人次观看，适用于培训、带货、会议、活动等企业直播场景，企业私域直播SaaS系统，就选七牛云！',
                }
            }
        },
    ],
});
router.beforeEach((to, from, next) => {
    if (to.meta.content) {
        let head = document.getElementsByTagName("head");
        let meta = document.createElement("meta");
        document.querySelector("meta[name='keywords']").setAttribute("content", to.meta.content.keywords)
        document.querySelector("meta[name='description']").setAttribute("content", to.meta.content.description)
        meta.content = to.meta.content;
        head[0].appendChild(meta)
    }
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    /* 记住刷新前路由 */
    next();
});
export default router;